export default "__VITE_ASSET__CPvprzOR__"